module.exports = __webpack_public_path__ + "static/media/american-expre-texto.d55b6e0f.svg";